import { render, staticRenderFns } from "./ImagesCarousel.vue?vue&type=template&id=a4ddabc8"
import script from "./ImagesCarousel.vue?vue&type=script&lang=js"
export * from "./ImagesCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports